import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Office routing (v4/api,
 * `App\Settings\Easeedesk\EaseedeskOfficeRouting`): "tichetele oamenilor din
 * sediul X pleaca la echipa Y / omul Z". Fara nicio regula, nimic nu se
 * schimba.
 */

export interface OfficeRoutingRule {
  ID: number
  company_id: number
  company_name: string
  office_id: number
  office_name: string
  group_id: number
  group_name: string
  assignee: number
  assignee_name: string
  enabled: number
}

export interface OfficeRoutingPage {
  title: string
  rules: OfficeRoutingRule[]
  offices: { ID: number; name: string; company_id: number; company_name: string }[]
  groups: { ID: number; name: string }[]
  staff: { ID: number; name: string; group_id: number }[]
  canSave: boolean
}

export interface OfficeRoutingAnswer {
  status?: string
  id?: number
  message: string
}

export function officeRoutingQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'office_routing'],
    queryFn: () => apiGet<OfficeRoutingPage>('/settings/easeedesk/office_routing'),
  })
}

export function saveOfficeRoute(rule: { office_id: number; group_id: number; assignee: number; enabled: boolean }) {
  return apiPost<OfficeRoutingAnswer>('/settings/easeedesk/office_routing', {
    office_id: rule.office_id,
    group_id: rule.group_id,
    assignee: rule.assignee,
    enabled: rule.enabled ? '1' : '0',
  })
}

export function removeOfficeRoute(id: number) {
  return apiPost<OfficeRoutingAnswer>(`/settings/easeedesk/office_routing/${id}/remove`, {})
}
